module.exports = __webpack_public_path__ + "img/arty3 (Teléfono).6fd5deb7.png";